import { render } from "./gsrbr0403.vue?vue&type=template&id=65dc9eac&scoped=true"
import script from "./gsrbr0403.vue?vue&type=script&lang=js"
export * from "./gsrbr0403.vue?vue&type=script&lang=js"

import "./gsrbr0403.vue?vue&type=style&index=0&id=65dc9eac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65dc9eac"]])

export default __exports__